import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================

        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/changeprofile',
          name: 'changeprofile',
          component: () => import('./views/apps/ChangeProfile.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/profile-and-bank-accounts',
          name: 'profileAndBankAccounts',
          component: () => import('./views/apps/ProfileAndBankAccounts.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/exchange-rate',
          name: 'exchangeRate',
          component: () => import('./views/apps/ExchangeRate.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        // {
        //   path: '/add-account',
        //   name: 'addAccount',
        //   component: () => import('./views/AddAccount.vue'),
        //   meta: {
        //     hideNavbar: false,
        //   },
        // },
        {
          path: '/payments',
          name: 'payments',
          component: () => import('./views/apps/Transactions.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/refunds',
          name: 'refunds',
          component: () => import('./views/apps/Refunds.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/no-accounts',
          name: 'no-accounts',
          component: () => import('./views/apps/NoAccounts.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/home',
          name: 'home',
          component: () => import('./views/apps/Dashboard.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/fiat-payout-admin',
          name: 'fiat-payout-admin',
          component: () => import('./views/apps/FiatPayoutHistory.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        // {
        //   path: '/settings',
        //   name: 'settings',
        //   component: () => import('./views/apps/Settings.vue'),
        //   meta: {
        //     hideNavbar: false,
        //   },
        // },

        {
          path: '/payment-link',
          name: 'payment-link',
          component: () => import('./views/apps/CreatePaymentLink.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/customize',
          name: 'customize',
          component: () => import('./views/apps/Customization.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/payment-options',
          name: 'payment-options',
          component: () => import('./views/apps/PaymentOptions.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-crypto-payout',
          name: 'create-crypto-payout',
          component: () => import('./views/apps/CreateWithdrawal.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-crypto-payout/:type',
          name: 'create-crypto-payout',
          component: () => import('./views/apps/CreateWithdrawal.vue'),
          props: true,
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-crypto-payout/',
          name: 'create-crypto-payout',
          component: () => import('./views/apps/CreateWithdrawal.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/crypto-payout-admin',
          name: 'crypto-payout-admin',
          component: () => import('./views/apps/PayoutHistory.vue'),
          props: route => ({ status: route.query.status, pytBatchId: route.query.batch_id, isBatch: false }),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/crypto-payout-admin/batch',
          name: 'crypto-batch-history',
          component: () => import('./views/apps/PayoutHistory.vue'),
          props: route => ({ batchStatus: route.query.status, batchId: route.query.batch_id, isBatch: true }),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/fiat-payout-admin',
          name: 'fiat-payout-admin',
          component: () => import('./views/apps/FiatPayoutHistory.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-fiat-payout',
          name: 'fiat-payout-creation',
          component: () => import('./views/apps/FiatPayoutCreation.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-fiat-account/beneficiary',
          name: 'create-fiat-beneficiary-account',
          component: () => import('./views/apps/FiatAccountCreation.vue'),
          props: { isBeneficiary: true },
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/create-fiat-account/sender',
          name: 'create-fiat-sender-account',
          component: () => import('./views/apps/FiatAccountCreation.vue'),
          props: { isBeneficiary: false },
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/manage-fiat-accounts',
          name: 'manage-fiat-accounts',
          component: () => import('./views/apps/ManageFiatAccounts.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/manage-users',
          name: 'Manage Users',
          component: () => import('./views/apps/ManageUsers'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/authentication-page',
          name: 'Authentication Page',
          component: () => import('./views/apps/AuthenticationPage'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/reset-secret',
          name: 'Secret reset Page',
          component: () => import('./views/apps/ResetSecretPage'),
          meta: {
            hideNavbar: false,
          },
        },

        {
          path: '/api-credentials',
          name: 'Api credentials Page',
          component: () =>
            import(
              /* webpackChunkName: "ApiCredentials" */ './views/apps/ApiCredentialsPage'
            ),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/statements',
          name: 'Statements',
          component: () => import('./views/apps/Statements.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/withdrawals',
          name: 'Withdrawals',
          component: () => import('./views/apps/Withdrawals.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/deposits',
          name: 'Deposits',
          component: () => import('./views/apps/Deposits.vue'),
          meta: {
            hideNavbar: false,
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            hideNavbar: true,
          },
        },
        {
          path: '/login',
          name: 'Login',
          component: () =>
            import(/* webpackChunkName: "Login" */ '@/views/pages/Login.vue'),
          props: (route) => ({
            code: route.query.code,
            userEmail: route.query.email,
          }),
          meta: {
            hideNavbar: true,
          },
        },
        {
          path: '/logout',
          name: 'Logout',
          component: () => import('./views/pages/Logout.vue'),
          meta: {
            hideNavbar: false,
          },
        },
        {
          path: '/reset-password',
          name: 'ResetPassword',
          component: () => import('./views/pages/ResetPasswordWithToken.vue'),
          meta: {
            hideNavbar: true,
            public: true,
          },
        },
        {
          path: '/error-404',
          name: 'Error404',
          component: () => import('./views/pages/Error404.vue'),
        },

        // {
        //   path: '/refund-form',
        //   name: 'refundForm',
        //   component: () => import('./views/pages/RefundForm.vue')
        // },
        {
          path:
            '/payment-request/:apiId?/:currencyFrom?/:currencyTo?/:invoiceAmount?/:invoiceNumber?',
          name: 'paymentRequest',
          component: () => import('./views/pages/PaymentRequest.vue'),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404',
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

router.beforeEach((to, from, next) => {
  store.commit('SET_NEXT_ROUTE_PATH', to.path);
  const capitalizedName = to.name
    ? to.name.charAt(0).toUpperCase() +
      to.name.slice(1) +
      ' - Triple-A Dashboard'
    : 'Triple-A Dashboard - Manage your cryptocurrency accounts';

  if (to.meta.public) {
    // for pages that dont need to be logged in (ex: /reset-password)
    document.title = capitalizedName;
    return next();
  }

  if (to.query.code && to.fullPath.startsWith('/login')) {
    // User coming from Backoffice
    return next();
  }
  if (
    (!store.state.activeUser || !store.state.activeUser.userToken) &&
    !to.fullPath.startsWith('/login')
  ) {
    next('/login');
  } else if (
    store.state.activeUser &&
    store.state.activeUser.userToken &&
    to.fullPath.startsWith('/login')
  ) {
    next('/home');
  } else {
    document.title = capitalizedName;
    next();
  }
});

export default router;
